module.exports = __webpack_public_path__ + "img/关于我们pic.c26c3cef.png";